<!--
 * @Author: zl
 * @Date: 2021-12-09 11:04:38
 * @LastEditTime: 2024-04-15 13:47:09
 * @LastEditors: wang_shuai 591372242@qq.com
 * @Description: 添加内容
-->
<template>
	<div class="h100 add-content-layout">
		<el-form ref="contentForm" :model="contentForm" label-width="120px" :rules="contentRule" size="small">
			<el-row :gutter="10">
				<el-col :span="16">
					<el-form-item label="标题：" prop="title">
						<el-input v-model="contentForm.title" placeholder="请输入" :disabled="isDisabled" maxlength="20" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="目录：" prop="ml">
						{{ contentForm.ml }}
					</el-form-item>
					<el-form-item label="内容：" prop="content">
						<wang-editor v-model="contentForm.content" ref="wangEditor" height="100%" :isViewMode="isDisabled"></wang-editor>
					</el-form-item>
					<el-form-item label="附件：">
						<public-upload
							ref="upload"
							tableName="operate_help_detail"
							assortment="content"
							:aid="contentForm.id"
							width="100%"
							:maxNum="999"
							:needRefresh="false"
							:mode="mode"
							:acceptType="[]"
							:fileSize="500"
							:disabled="isDisabled"
						></public-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<div class="footer text-center" :class="{ hidden: mode == 'view' }">
			<el-button type="primary" class="btn-blue" icon="el-icon-position" size="mini" :loading="btnLoading" @click="handler('1')"
				>发布</el-button
			>
			<el-button type="primary" class="btn-blue" icon="el-icon-tickets" size="mini" :loading="btnLoading" @click="handler('0')">保存</el-button>
		</div>
	</div>
</template>
<script>
import * as API from 'api/modules/rulesManagement'
import { Snowflake } from 'node-snowflake'
export default {
	props: {
		selectName: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			contentForm: {
				title: '', // 标题
				catalogId: '', //目录
				ml: '',
				content: '', // 内容
				id: Snowflake.nextId(),
				status: '',
				isAdd: true
			},
			contentRule: {
				title: [{ required: true, message: '不能为空...' }],
				content: [{ required: true, message: '不能为空...' }]
			},
			btnLoading: false
		}
	},
	created() {
		this.contentForm.ml = this.selectName
		if (this.mode != 'add') {
			this.contentForm.title = this.rowData.title
			this.contentForm.catalogId = this.rowData.catalogId
			this.contentForm.id = this.rowData.id
			this.contentForm.ml = this.rowData.catalogue
			this.contentForm.isAdd = false
			this.contentForm.content = this.rowData.content
		}
	},
	mounted() {
		// if (this.mode != 'add') {
		// 	this.$refs.editor.content = this.rowData.content
		// }
	},
	methods: {
		// 按钮点击事件
		handler(data) {
			this.$refs.contentForm.validate((valid) => {
				this.btnLoading = true
				if (valid) {
					let params = this.$utils.clone(this.contentForm, true)
					params.status = data
					params.catalogId = this.rowId
					API.saveOrEditHelpDetail(params)
						.then((res) => {
							// this.$refs.upload.fileSend(res.data.id)
							this.$message.success('操作完成！')
							this.goBack()
						})
						.catch(() => {
							this.btnLoading = false
						})
				} else {
					this.$message.error('请完善表单！')
					this.btnLoading = false
				}
			})
		},

		// 返回上一层
		goBack() {
			this.$router.push({
				path: '/redirect/helpCenter'
			})
		}
	},
	computed: {
		mode() {
			return this.$route.query.type
		},

		rowId() {
			return this.$route.query.id
		},

		isDisabled() {
			return this.$route.query.type == 'view'
		}
	},
	watch: {
		'contentForm.content': {
			handler(val, oldval) {
				this.$refs.contentForm.validateField('content')
			},
			deep: true
		}
	}
}
</script>
<style lang="less" scoped>
.add-content-layout {
	padding: 40px 0;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	.footer {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
}
</style>
